import {getAttachment} from 'polyphony/networking';

/*
    This is a rawer version of MediaPicker. It provides a simple
    interface to render your own media picker.
*/

/* TODO: multiple */

const openMediaPicker = (selectedMedia, onSelect, type=null, multiple=false) => {
    if (!type) type = ['video', 'image'];
    let p = wp.media({
        title: 'Select Media',
        multiple,
        library: {type}
    });

    p.on('select', () => {
         let selection = p.state().get('selection');
         if (selection) {
             if (multiple) {
                 Promise.all(selection.toArray().map(x => getAttachment(x.id))).then(onSelect);
             } else if (selection.length === 1) {
                 let id = selection.first().id;
                 getAttachment(id).then(onSelect);
             }
        }
    });

    p.on('open', () => {
        let selection = p.state().get('selection');
        if (selectedMedia) {
            if (multiple) {
                selection.add(selectedMedia.map(({id}) => wp.media.attachment(id)).filter(Boolean));
            } else {
                let a = wp.media.attachment(selectedMedia.id);
                if (a) {
                    selection.add([a]);
                }
            }
        }
    });

    p.open();

    return () => p.close();
};

const BaseMediaPicker = ({selectedMedia, onSelect, type, multiple, children}) =>
    children(() => openMediaPicker(selectedMedia, onSelect, type, multiple));

// Support legacy
BaseMediaPicker.openMediaPicker = openMediaPicker;

export default BaseMediaPicker;

